import { AlertSubscriptionSchema } from '../base.js';
export const CreateAlertSubscriptionBodyRequestSchema = AlertSubscriptionSchema.pick({
    alertLevel: true,
    email: true,
});
export const CreateAlertSubscriptionRequestSchema = CreateAlertSubscriptionBodyRequestSchema;
export const CreateAlertSubscriptionResponseSchema = AlertSubscriptionSchema;
